import { useState } from 'react';
import { Loading } from '../components/Loading';
import { Pagination } from '../components/Pagination';
import ErrorMessageBox from '../components/ErrorMessageBox';
import { AuthorListItem } from './AuthorListItem';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';

const AuthorMeetingList = ()=>{
	const [page, setPage] = useState(0);
	

	const { data:meetingList, isFetching, isError, error} = useQuery({
		queryKey:['meeting/list', page],
		queryFn:()=>Api.get(`/api/meeting/list?page=${page}`)
	})
	
	if( isError ) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;

	
	meetingList?.data?.list.map((item)=>{
		return <AuthorListItem item={item} key={item.id} />;
	});
	
	return (
		<div className="section writer_meeting_list">
			<div className="inner">
				<h2 className="pdB0"><span>명예의 전당</span></h2>
				<div className="video_list clear">
					{  meetingList?.data?.list.map((item)=><AuthorListItem item={item} key={item.id} />) }
					<Loading overlay={true} active={isFetching} />
				</div>
				<Pagination page={meetingList?.data?.page} totalPage={meetingList?.data?.totalPages} gotoPage={(newPage)=>setPage(newPage)} />
			</div>
		</div>
	);
}

export default AuthorMeetingList;

